export default {
    nlfAgentRating: {
        defaults: {
            endpoint: '/api/v3/nlf-agent/query-log/rating',
        },
        create: {
            params: {}
        }
    }
}
